import { render, staticRenderFns } from "./NormalFileButton.vue?vue&type=template&id=1d851f20&scoped=true"
import script from "./NormalFileButton.vue?vue&type=script&lang=js"
export * from "./NormalFileButton.vue?vue&type=script&lang=js"
import style0 from "./NormalFileButton.vue?vue&type=style&index=0&id=1d851f20&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d851f20",
  null
  
)

export default component.exports